import axios from 'axios'
import { useEffect, useState } from 'react'
import { serverUrl } from '../../../../../utilites/config'

export const TECHNICAL_DAY_REFRESH_MS = 5 * 60 * 1000

interface TechnicalDayStatus {
  technicalDay: boolean
}

export function useTechnicalDay(): boolean {
  const [isTechnicalDay, setIsTechnicalDay] = useState(false)

  useEffect(() => {
    let isActive = true

    const refreshTechnicalDay = async () => {
      try {
        const { data } = await axios.get<TechnicalDayStatus>(`${serverUrl}/technical-days/today`)
        if (isActive) {
          setIsTechnicalDay(data.technicalDay)
        }
      } catch (error) {
        console.error('[TechnicalDay] Failed to refresh technical day status:', error)
      }
    }

    refreshTechnicalDay()
    const intervalId = window.setInterval(refreshTechnicalDay, TECHNICAL_DAY_REFRESH_MS)

    return () => {
      isActive = false
      window.clearInterval(intervalId)
    }
  }, [])

  return isTechnicalDay
}
